import { fa } from '../i18n/fa';

export default function CommodityTabs({ items, value, onChange }) {
  return (
    <div className="tr-tabs" role="tablist">
      {items.map((c) => (
        <button
          key={c.key}
          type="button"
          role="tab"
          aria-selected={c.key === value}
          className={c.key === value ? 'on' : ''}
          onClick={() => onChange(c.key)}
        >
          {fa.commodityLabel(c.key)}
        </button>
      ))}
    </div>
  );
}
